import React from 'react';
import { useField } from 'formik';
import styled from 'styled-components';

import { FormLabel as Label, Phone } from '~ui-kit';
import Error from '../components/Error';
import FieldContextFeeder from '../components/FieldContextFeeder';

const PhoneField = ({ required, instruction, ...props }) => {
  const [field, meta] = useField(props);
  const error = meta.error && meta.touched;

  return (
    <Container>
      <Label
        required={required}
        htmlFor={props.id || props.name}
        info={props.info}
      >
        {props.label}
      </Label>
      <Phone {...field} {...props} error={error} />
      <Instructions>
        {instruction || 'Kirjoita muotoon 04012345678'}
      </Instructions>
      {error ? <Error>{meta.error}</Error> : null}
    </Container>
  );
};

const Container = styled.div`
  max-width: var(--field-width);
`;

const Instructions = styled.div`
  font-size: 14px;
  color: var(--blue);
  margin-top: 8px;
`;

export default FieldContextFeeder(PhoneField);
